export default function Features() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: '无需下载安装',
      description: '打开浏览器即可使用，省去繁琐的下载和安装流程，节省设备存储空间，即开即用更便捷。',
    },
    {
      icon: 'ri-device-line',
      title: '多端完美适配',
      description: 'PC端、手机端、平板端全平台自动适配，无论使用什么设备都能获得流畅一致的使用体验。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全可靠保障',
      description: '采用TLS 1.3加密传输和AES-256数据加密，多层安全防护体系守护您的每一份数据。',
    },
    {
      icon: 'ri-rocket-2-line',
      title: '持续迭代更新',
      description: '产品团队持续优化升级，新功能不断推出。网页端自动更新，无需用户手动操作。',
    },
    {
      icon: 'ri-team-line',
      title: '实时协作支持',
      description: '支持多人同时在线协作编辑，修改实时同步，保留完整版本历史，团队效率大幅提升。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '贴心客户服务',
      description: '提供全天候在线客服支持，快速响应用户需求。丰富的使用教程和帮助文档，让使用无门槛。',
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择爱液网页版
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            爱液网页版致力于为用户提供最便捷的在线服务体验，六大核心优势让您的工作与生活更加高效
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="group p-6 rounded-xl bg-background-100/70 border border-background-200/60 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1 cursor-default"
            >
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}